import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import { useLocalization } from 'redux/localization/utils/hooks';

// Don't show the spinner until 1 second has passed
const delay = 1000;

const Loading = (props) => {
  const { as = 'div', isDelay = true } = props;
  const [isVisible, setVisible] = useState(!isDelay);
  const timeoutRef = useRef();
  const { t } = useLocalization();

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setVisible(true);
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  if (as === 'span') {
    return (
      <span className="c7-loading--inline">
        <span
          className={classNames('c7-spinner', {
            'c7-spinner--hidden': !isVisible
          })}
        />
      </span>
    );
  }

  return (
    <div className="c7-loading--block">
      <div
        className={classNames('c7-spinner c7-spinner--large', {
          'c7-spinner--hidden': !isVisible
        })}
        role="status"
        aria-live="polite"
      >
        <span className="c7-sr-only">{t('general.accessibility.loading')}</span>
      </div>
    </div>
  );
};

export default Loading;
